function middlewarePipeline(context, middleware, index) {
  const nextMiddleware = middleware[index]

  if (!nextMiddleware) {
    return context.next
  }

  return (...navigationParams) => {
    // If a redirect was initiated, stop the pipeline
    if (navigationParams[0] && (navigationParams[0].path || navigationParams[0].name)) {
      return context.next(...navigationParams)
    }

    nextMiddleware(context.routeTo, context.routeFrom, middlewarePipeline(context, middleware, index + 1))
  }
}

export default middlewarePipeline
